import "./Entry.scss";
import bimLogo from "static/images/bim_logo.svg";

const EntryWrap = ({ children }) => {
  return (
    <div className="entry">
      <div className="entry-container">
        <div className="entry-left">
          {children}
        </div>

        <div className="entry-right">
          <div className="logo">
            <img
              src={bimLogo}
              alt="Logotype"
            />
          </div>
          <h1>
            Nearly there!
          </h1>

          <p>
            Just a few more steps and you’ll have your project at your fingertips
          </p>
        </div>
      </div>
    </div>
  );
};

export default EntryWrap;
